module.exports = __webpack_public_path__ + "static/media/cross.beb19381.svg";